import ApiClient from '../ApiClient';

const RedditService = {
  async post({ title, subreddit, imageUrl, accessToken }) {
    const payload = { title, subreddit, imageUrl, accessToken };
    const resp = await ApiClient.post('/SocialAuth/reddit/post', payload);
    return resp.data;
  }
};

export default RedditService;
